import React from 'react';
import './TractDetail.scss';
import Button from '../../../controls/forms/redesign/FormButton';
import { Form, Field, AnyObject } from 'react-final-form';

import { RouteComponentProps } from 'react-router';
import moment from 'moment';

import ExaminedHistoryDialog from './ExaminedHistory';

import TractDetailData from 'src/models/tract_detail/TractDetail';
import PropertyUtil from 'src/util/PropertyUtil';
import TractDetailFormData from 'src/models/tract_detail/TractDetailFormData';
import ExaminedHistoryChanges from 'src/models/tract_detail/ExaminedHistoryChanges';
import Ownership from 'src/models/tract_detail/Ownership';
import AddOwnershipCollection from 'src/models/tract_detail/add_ownership_collection/AddOwnershipCollection';
import NewTract from 'src/models/tract_detail/NewTract';
import DialogList from 'src/dialogs';
import FormRow from 'src/components/controls/forms/FormRow';
import { Formation, HorizonInterval } from 'src/models/Horizon';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import County from 'src/models/County';
import { SelectItem } from 'src/models/common/SelectItem';
import WrappedForm from 'src/components/controls/forms/Form';
import Textbox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import { FormErrors } from 'src/util/FormErrors';
import { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';
import Horizon from 'src/models/tract_detail/Horizon';
import SearchResult from 'src/models/OwnerSearchResult';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import CreateHorizonDto from 'src/models/tract_detail/CreateHorizonDto';
import HorizonIntervalComponent from './AddHorizonComponents/HorizonIntervalComponent';
import HorizonSequencingComponent from './AddHorizonComponents/HorizonSequencingComponent';
import Township from 'src/models/Township';
import Section from 'src/models/Section';
import Leasehold from 'src/models/leasehold/Leasehold';
import OwnerListFilter from './OwnerListFilter';
import State from 'src/models/State';
import _ from 'lodash';
import FormTextArea from 'src/components/controls/forms/redesign/FormTextArea';
import OwnershipList from './OwnershipList';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import { push } from 'connected-react-router';
import actions from 'src/actions';
import { connect } from 'react-redux';
import Owner from 'src/models/tract_detail/Owner';
import IOwner from 'src/models/IOwner';
import HorizonSection, { IHorizonSectionProps } from '../tract/components/HorizonSection';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
// import CloneHorizonDataComponent from './AddHorizonComponents/CloneHorizonDataComponent';
import CloneHorizon from 'src/models/CloneHorizon';
import DeleteConfirmDialog from 'src/components/admin/DeleteConfirmDialog';
import PhoneNumberType from 'src/models/PhoneNumberType';
import ManageLeaseholdDialog from './ManageLeaseholdDialog';
import Tract from 'src/models/Tract';
import ManageAgreementDialog from './ManageAgreementsDialog';
// import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
import USPSCityState from 'src/models/USPSCityState';
// import Card from 'src/components/common/Card.redesign';
// import CardContainer from 'src/components/common/CardContainer.redesign';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { LandSystem } from 'src/models/LandSystem';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import { convertInstrumentTypesToSelectList } from 'src/models/InstrumentType';
// import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import { DialogContext, dialogCreators } from '../../../../providers/DialogProvider';
// import PDFWindow from 'src/components/common/PDFWindow';
// import TractMorReport from 'src/components/reports/ownership/TractMorReport';
import TractDetailDocs from '../LeasingComponents/TractDetailDocs';
import SurfaceOwnershipList from '../tract/components/SurfaceOwnershipList';
import EastTexasSurveyPanel from './panels/EastTexasSurveyPanel';
// import TractTagsPanel from './panels/TractTagsPanel';
import Project from 'src/models/Project';
import ReactTags, { Tag } from 'react-tag-autocomplete';
import { TagComponent } from 'src/components/controls/forms/redesign/TagComponents';
import Lease from 'src/models/leasehold/Lease';
import Dialog from 'src/components/common/Dialog';
import CreateHorizonDialog from '../tract/dialogs/CreateHorizonDialog';
import MathUtil from 'src/util/MathUtil';
import { ITableConfig } from 'src/components/common/table';
import { OwnershipLeaseBuyerForm } from 'src/models/OwnershipLeaseBuyer';
import ProjectStaff from 'src/models/ProjectStaff';
import OwnerUtil from 'src/util/OwnerUtil';
import EasternTownship from 'src/models/EasternTownship';
import EasternMap from 'src/models/EasternMap';

export interface ITractDetailDispatchProps {
    initializeTractsPage: () => void;
    dumpOwnershipContactCategories: () => void;
    navigate: (path: string, search?: string) => void;
    getPhoneNumberTypes: () => void;
    getTractDetail: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions
    ) => void;
    deleteHorizon: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number) => void;
    getCloneTractDetail: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => void;
    getCloneTracts: (clientNumber: number, projectNumber: number, sectionNumber: number) => void;
    getCloneSections: (clientNumber: number, projectNumber: number, townshipId: number) => void;
    getCloneTownships: (clientNumber: number, projectNumber: number) => void;
    getTownships: (clientNumber: number, projectNumber: number) => void;
    getEasternTownships: (clientNumber: number, projectNumber: number) => void;
    getTownship: (clientNumber: number, projectNumber: number, townshipId: number) => void;
    getEasternTownship: (clientNumber: number, projectNumber: number, townshipId: number) => void;

    saveTractDetail: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        formValues: TractDetailFormData
    ) => void;
    createHorizon: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        createHorizonDto: CreateHorizonDto
    ) => void;
    saveExaminedHistory: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        examinedHistoryChanges: ExaminedHistoryChanges
    ) => void;
    getLeaseholdsByTract: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => void;
    getOwnerDetail: (clientNumber: number, projectNumber: number, ownerId: number, containerId: number, type: string) => void;
    saveAddOwnershipCollection: (clientNumber: number, projectNumber: number, addOwnershipCollection: AddOwnershipCollection) => void;
    createTract: (clientNumber: number, projectNumber: number, sectionNumber: number, values: NewTract) => void;
    showDialog: (dialogName: string) => void;
    searchOwners: (clientNumber: number, projectNumber: number, searchString: string, ownerType: string) => void;
    getFormations: (clientNumber: number, projectNumber: number) => void;
    createFormation: (clientNumber: number, projectNumber: number, formation: Formation) => void;
    getPagedOwnerships: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions
    ) => void;
    getSectionCounties: (clientNumber: number, projectNumber: number, sectionNumber: number, options: ODataOptions) => void;
    getEasternMapCounties: (clientNumber: number, projectNumber: number, mapNumber: number, options: ODataOptions) => void;
    getProjectCounties: (clientNumber: number, projectNumber: number, options: ODataOptions) => void;
    getTractsByOwner: (clientNumber: number, projectNumber: number, sectionNumber: number, ownerId: number) => void;
    clearTractDetail: () => void;
    sequenceHorizons: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        sequence: Array<{ id: number; sequence: number }>
    ) => void;
    getUniqueHorizonIntervals: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => void;
    addCounty: (clientNumber: number, projectNumber: number, county: County) => void;
    saveAddOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        values: AddOwnershipData
    ) => void;
    addDeviation: (clientNumber: number, projectNumber: number, values: AddOwner, containerOwnerId: number, ownerType: string) => void;
    updateHorizonInterval: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonId: number,
        horizon: HorizonInterval
    ) => void;
    updateTractNote: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        tractDetailData: TractDetailData
    ) => void;
    updateOwnershipNote: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownership: Ownership
    ) => void;
    getLeaseholds: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, ownershipId: number) => void;
    getContracts: (clientNumber: number, projectNumber: number, ownershipId: number, inHanded: boolean) => void;
    updateLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        leaseholds: Array<Leasehold>
    ) => void;
    hideDialog: () => void;
    getStates: (options: ODataOptions) => void;
    deleteOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number,
        ownershipOptions: ODataOptions
    ) => void;
    getOwnershipContactCategories: (clientNumber: number, projectNumber: number) => void;
    getProjectStaff: (clientNumber: number, projectNumber: number) => void;
    clearError: () => void;
    manageLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        hoirzonNumber: number,
        ownershipId: number
    ) => void;
    incrementOwnershipPage: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number) => void;
    initializeOwnershipList: (config: ITableConfig) => void;
    initializeOwnerTracts: () => void;
    clearSearchResults: () => void;
    promoteAdditionalOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        hoirzonNumber: number,
        ownershipId: number
    ) => void;
    verifyId: (context: string, id: string) => void;
    clearVerification: () => void;
    setVerificationMessage: (message: string) => void;
    cloneData: (context: string, options: string) => void;
    // navigateAcquisition: (clientNumber: number, projectNumber: number, ownerLookUpId: number) => void;
    getCityState: (zipCode: string) => void;
    incrementAcqPage: (clientNumber: number, projectNumber: number) => void;
    getProjectTags: (clientNumber: number, projectNumber: number) => void;
    registerOwnerships: (ownerships: PagedResultSet<Ownership>, selectedHorizon: number) => void;
    getMap: (clientNumber: number, projectNumber: number, mapNumber: number) => void;
}

type TractDetailState = {
    tract: number;
    horizon: number;
    section: number;
    note: number;
    isNoteDialogVisible: boolean;
    isOwnerSearchDialogVisible: boolean;
    isAddTractDialogVisible: boolean;
    parentOwnershipId: number;
    ownershipNotesId: number;
    addFormationShowing: boolean;
    cloneHorizonData: CloneHorizon;
    cloneHorizons: Array<HorizonInterval>;
    deleteHorizonText: string;
    selectedOwnerLookUpId: number;
    selectedOwner: Owner;
    selectedOwnership: Ownership;
    selectedSurfaceOwnership: Ownership;
    getCountiesCalled: boolean;
    tags: Array<Tag>;
    dialogParams: IHorizonSectionProps;
    unsavedChanges: boolean;
    rerender: Object;
    isMapRequested: boolean;
    isTownshipsRequested: boolean;
};

export type ITractDetailStoreProps = {
    tractDetail: TractDetailData;
    currentProject: Project;
    projectCounties: PagedResultSet<County>;
    sectionCounties: PagedResultSet<County>;
    mapCounties: PagedResultSet<County>;
    formations: Array<Formation>;
    uniqueHorizonIntervals: Array<HorizonInterval>;
    selectedCounty: number;
    searchOwnersResults: Array<SearchResult>;
    cloneTract: TractDetailData;
    cloneTracts: Array<TractDetailData>;
    cloneSections: Array<Section>;
    cloneTownships: Array<Township>;
    leaseholds: Array<Leasehold>;
    tractLeaseholds: Array<Leasehold>;
    ownerDetails: Array<IOwner>;
    states: PagedResultSet<State>;
    testMode: boolean;
    ownershipContactCategories: OwnershipContactCategoryForm;
    ownerships: PagedResultSet<Ownership>;
    ownershipPageConfig: ITableConfig;
    errorMessage: string;
    projectStaff: PagedResultSet<ProjectStaff>;
    phoneNumberTypes: Array<PhoneNumberType>;
    ownerTracts: Array<Tract>;
    idVerificationMessage: string;
    idVerificationResult: boolean;
    agreements: Array<Lease>;
    uspsCityState: USPSCityState;
    projectTags: Array<Tag>;
    townships: Array<Township>;
    easternTownships: Array<EasternTownship>;
    township: Township;
    easternTownship: EasternTownship;
    easternMap: EasternMap;
};

type ITractDetailProps = RouteComponentProps<{
    clientNumber?: string;
    projectNumber?: string;
    sectionNumber?: string;
    mapNumber?: string;
    tractNumber?: string;
    horizonNumber?: string;
}> &
    ITractDetailDispatchProps &
    ITractDetailStoreProps;

export class TractDetail extends React.Component<ITractDetailProps, TractDetailState> {
    private clientNumber: number;
    private projectNumber: number;
    private sectionNumber: number;
    private mapNumber: number;
    private fieldNumber: number;
    private tractNumber: number;
    private horizonNumber: number;
    private isAddingTract: boolean;
    private form: FormApi;
    private initialValues: AnyObject;
    private cloneHorizonData: CloneHorizon;

    private surfaceOwnershipsRef = React.createRef();
    private tagsRef = React.createRef<ReactTags>();

    private landSystem: LandSystem = undefined;

    constructor(props: ITractDetailProps) {
        super(props);

        this.state = {
            tract: 0,
            horizon: 0,
            section: 0,
            note: 0,
            cloneHorizonData: undefined,
            isNoteDialogVisible: false,
            isOwnerSearchDialogVisible: false,
            isAddTractDialogVisible: false,
            parentOwnershipId: 0,
            addFormationShowing: false,
            ownershipNotesId: 0,
            cloneHorizons: undefined,
            deleteHorizonText: undefined,
            // seletedOwnerLookUpId: undefined,
            selectedOwner: undefined,
            selectedOwnership: undefined,
            selectedSurfaceOwnership: undefined,
            selectedOwnerLookUpId: undefined,
            // selectedOwner: undefined,
            getCountiesCalled: false,
            tags: [],
            dialogParams: undefined,
            unsavedChanges: false,
            rerender: new Object,
            isMapRequested: false,
            isTownshipsRequested: false,
        };
    }

    private dialogCreators: dialogCreators;
    static contextType = DialogContext;

    componentDidMount() {
        this.dialogCreators = this.context;

        window.scrollTo(0, 0);
        this.props.initializeTractsPage();
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.projectNumber = parseInt(this.props.match.params.projectNumber, 10);
        this.sectionNumber = parseInt(this.props.match.params.sectionNumber, 10);
        this.tractNumber = parseInt(this.props.match.params.tractNumber, 10);
        this.horizonNumber = parseInt(this.props.match.params.horizonNumber, 10);
        this.mapNumber = parseInt(this.props.match.params.mapNumber, 10);
        const index = _.findIndex(
            this.props.tractDetail?.horizons?.map((x) => {
                return { horizon: x, horizonNumber: x.horizonInterval.horizonNumber };
            }),
            { horizonNumber: this.horizonNumber }
        );
        if (index >= 0) {
            this.setState({ horizon: index });
        }

        this.fieldNumber = this.sectionNumber;
        if (isNaN(this.sectionNumber)) {
            this.fieldNumber = this.mapNumber;
            this.landSystem = LandSystem.Eastern;
        }

        if (this.props.match.params.tractNumber) {
            this.tractNumber = parseInt(this.props.match.params.tractNumber, 10);
            this.isAddingTract = false;
        } else {
            this.tractNumber = 0;
            this.isAddingTract = true;
        }

        // poc code
        this.props.getFormations(this.clientNumber, this.projectNumber);
        if (this.tractNumber) {
            this.props.getUniqueHorizonIntervals(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber);
        }

        if (!this.isAddingTract) {
            this.props.getTractDetail(
                this.clientNumber,
                this.projectNumber,
                this.fieldNumber,
                this.tractNumber,
                this.horizonNumber,
                new ODataOptions().addPaging(1, 5)
            );
        }

        this.props.getProjectStaff(this.clientNumber, this.projectNumber);

        this.props.getProjectTags(this.clientNumber, this.projectNumber);

        this.props.getOwnershipContactCategories(this.clientNumber, this.projectNumber);

        if (this.props.tractDetail) {
            if (isNaN(this.sectionNumber)) {
                this.props.tractDetail.landSystem = LandSystem.Eastern;
            }
        }

        const animatedButton = document?.getElementById('animatedRunsheetButton');

        if (!!animatedButton) {
            // Stop the animation after 5 seconds
            setTimeout(() => {
                animatedButton.style.animationPlayState = 'paused';
                animatedButton.style.animationIterationCount = '0';
                this.setState({ rerender: new Object });
            }, 20000);
        }
    }

    componentDidUpdate(prevProps: ITractDetailProps) {
        if (this.props.selectedCounty !== prevProps.selectedCounty) {
            this.form.change('CountyId', this.props.selectedCounty);
        }

        if (this.props.tractDetail !== prevProps.tractDetail && this.props.tractDetail !== undefined) {
            this.setState({ tags: this.props.tractDetail?.tags?.map((tag, index) => ({ id: index + 1, name: tag })) });

            if (isNaN(this.sectionNumber)) {
                this.props.tractDetail.landSystem = LandSystem.Eastern;
            }

            if (this.props.tractDetail.horizons) {
                this.setState({ cloneHorizons: this.props.tractDetail.horizons.map((horizon: Horizon) => horizon.horizonInterval) });
                const index = _.findIndex(
                    this.props.tractDetail.horizons.map((x) => {
                        return { horizon: x, horizonNumber: x.horizonInterval.horizonNumber };
                    }),
                    { horizonNumber: this.horizonNumber }
                );
                this.setState({ horizon: index });
            }
        }

        if (
            (this.state.getCountiesCalled === false && this.props.currentProject?.id !== 0) ||
            this.props.currentProject?.id !== prevProps.currentProject?.id
        ) {
            if (!this.props.currentProject) {
                return;
            }
            const countyOptions = new ODataOptions();

            this.setState({ getCountiesCalled: true });
            if (
                this.props.currentProject.landSystemId === LandSystem.Jeffersonian ||
                this.props.currentProject.landSystemId === LandSystem.WestTexas
            ) {
                this.props.getSectionCounties(this.clientNumber, this.projectNumber, this.fieldNumber, countyOptions);
            } else if (this.props.currentProject.landSystemId === LandSystem.EastTexas) {
                this.props.getProjectCounties(this.clientNumber, this.projectNumber, countyOptions);
            } else {
                this.props.getEasternMapCounties(this.clientNumber, this.projectNumber, this.fieldNumber, countyOptions);
            }
        }

        const fetchTownships = async () => {
            if (this.props.tractDetail?.townshipId) {
                if (this.props.currentProject?.landSystemId === LandSystem.Eastern) {
                    if (!this.props.easternMap && this.props.currentProject && !this.state.isMapRequested) {
                        this.setState({ isMapRequested: true });
                        await this.props.getMap(
                            this.props.currentProject?.client?.clientNumber,
                            this.props.currentProject?.projectNumber,
                            this.mapNumber,
                        );
                    }

                    if (!this.props.easternTownship && this.props.easternMap && !this.state.isTownshipsRequested) {
                        this.setState({ isTownshipsRequested: true });
                        await this.props.getEasternTownship(
                            this.props.currentProject?.client?.clientNumber,
                            this.props.currentProject?.projectNumber,
                            this.props.easternMap.easternTownshipId,
                        );
                    }
                }
            }
        };

        fetchTownships();
    }

    componentWillUnmount() {
        this.props.initializeTractsPage();
        this.props.dumpOwnershipContactCategories();
        this.props.clearError();
    }

    updateOwnershipNote = (ownership: Ownership) => {
        this.props.updateOwnershipNote(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, ownership);
    };

    changeHorizon = (horizonId: number) => {
        const index = _.findIndex(this.props.tractDetail.horizons, { id: horizonId });
        const horizonNumber = this.props.tractDetail.horizons[index].horizonInterval.horizonNumber;

        this.horizonNumber = horizonNumber;
        this.setState({ horizon: index });
        if (!isNaN(this.sectionNumber)) {
            this.props.navigate(
                `/clients/${this.clientNumber}/projects/${this.projectNumber}/sections/${this.sectionNumber}/tracts/${this.tractNumber}/horizons/${horizonNumber}`
            );
        } else {
            this.props.navigate(
                `/clients/${this.clientNumber}/projects/${this.projectNumber}/maps/${this.mapNumber}/tracts/${this.tractNumber}/horizons/${horizonNumber}`
            );
        }
        this.props.getTractDetail(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.horizonNumber,
            null
        );
        this.getOwnershipsForHorizon(horizonNumber);
    };

    getOwnershipsForHorizon = (horizonNumber: number) => {
        const ownershipOptions = new ODataOptions();
        this.props.getPagedOwnerships(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, horizonNumber, ownershipOptions);
    };

    onSaveExaminedHistory = (examinedHistoryChanges: ExaminedHistoryChanges) => {
        this.props.saveExaminedHistory(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.horizonNumber,
            examinedHistoryChanges
        );
    };

    onSubmit = (values: TractDetailFormData, form: FormApi) => {
        const valuesClone = _.cloneDeep(values);
        const propOwnerships = this.props.tractDetail.horizons[this.state.horizon].ownership.items;
        let ownershipList: Ownership[] = [];

        // Ownership numeric fields are edited/formatted as strings in the cards (e.g. net acres is
        // recalculated through MathUtil.cleanNumber, which returns a string). The API deserializes the
        // body with System.Text.Json, which rejects a JSON string -- or NaN, which serializes to null --
        // for a numeric property and fails to bind the whole request (-> null body -> 500). Coerce the
        // numeric fields back to real numbers before sending.
        const toSafeNumber = (value: number | string | null | undefined): number => {
            const parsed = parseFloat(`${value}`);
            return isNaN(parsed) ? 0 : parsed;
        };

        if (valuesClone.ownerships) {
            valuesClone.ownerships.map((ownership: Ownership, index: number) => {
                if (ownership) {
                    ownership.decimalInterest = toSafeNumber(ownership.decimalInterest);
                    ownership.netAcres = toSafeNumber(ownership.netAcres);
                    ownership.executiveRights = toSafeNumber(ownership.executiveRights);
                    if (ownership.leaseBuyer > 0 && propOwnerships[index].leaseBuyer !== ownership.leaseBuyer) {
                        ownershipList.push(ownership);
                    }
                    if (ownership.additionalOwnerships && ownership.additionalOwnerships.length > 0) {
                        ownership.additionalOwnerships.map((ao) => {
                            ao.decimalInterest = toSafeNumber(ao.decimalInterest);
                            ao.netAcres = toSafeNumber(ao.netAcres);
                            let existing = propOwnerships.find(po => po.id === ao.parentOwnershipId);
                            let aExisting = existing?.additionalOwnerships?.find(pa => pa.id === ao.id);
                            if (!!aExisting) {
                                ao.parentOwnershipId = aExisting.parentOwnershipId;
                                ao.additionalOwnershipTypeId = aExisting.additionalOwnershipTypeId;

                                if (ao.leaseBuyer > 0 && aExisting.leaseBuyer !== ao.leaseBuyer) {
                                    ownershipList.push(ao);
                                }
                            }
                        });
                    }
                }
            });
        }
        if (valuesClone.grossAcres) {
            valuesClone.grossAcres = parseFloat(valuesClone.grossAcres + '');
        }

        valuesClone.tractId = this?.props?.tractDetail?.id;
        valuesClone.tractNumber = this?.props?.tractDetail?.tractNumber;
        valuesClone.horizonId = this?.props?.tractDetail?.horizons[this.state.horizon]?.id;

        if (this.surfaceOwnershipsRef.current) {
            (this.surfaceOwnershipsRef.current as { saveForm: () => void }).saveForm();
        }

        valuesClone.tags = this.state.tags.map((x) => x.name);

        let staff = this.props.projectStaff?.items;
        let tDetails = valuesClone;
        let hDetails = this?.props?.tractDetail?.horizons[this.state.horizon];
        let counties = this.handleCounties();
        let lbList: OwnershipLeaseBuyerForm[] = [];

        for (let ownership of ownershipList) {
            let staffed = staff.find(ps => ps.id === ownership.leaseBuyer);
            let gross = tDetails.grossAcres;
            let netAcres = !(isNaN(gross) || isNaN(ownership.decimalInterest)) ? gross * ownership.decimalInterest : 0;
            let county = counties.find(c => c.id === valuesClone.countyId);
            let minCat = netAcres < 1 ? 'Less than one acre' : `${Math.floor(netAcres)} acre(s)`;
            let lStatus = !!ownership.leasedStatus ? ownership.leasedStatus : ownership.activeLeaseTypes?.length > 0 ? 'Active' : 'Open';
            let owner: Owner = PropertyUtil.SafeGet(() => this.props.tractDetail.owners).find((ow: Owner) => ow.ownerLookUpId === ownership.ownerLookUpId);
            let ownerName = OwnerUtil.FullOwnershipName(owner, ownership?.isCommunityProperty);

            let lb: OwnershipLeaseBuyerForm = {
                leaseBuyerEmail: staffed?.user.username,
                ccEmail: '',
                lessor: ownerName,
                globalId: `${this.clientNumber}.${this.projectNumber}.${this.fieldNumber}.${valuesClone.tractNumber}-${hDetails.horizonInterval.horizonNumber}`,
                tractDescription: `Tr ${valuesClone.tractNumber}, Hz ${hDetails.horizonInterval.horizonNumber}`,
                grossAcres: !isNaN(gross) ? gross : 0,
                netAcres: netAcres,
                county: !!county ? county.name : 'N/A',
                status: lStatus,
                addlOwners: !!ownership.additionalOwnerships ? ownership.additionalOwnerships.length : 0,
                mineralCategory: `Mineral Owners ${minCat}`,
                assignment: 'New Lease',
                sendEmail: false
            };

            lbList.push(lb);
        }

        if (ownershipList.length > 0) {
            this.dialogCreators.contract.emailLeaseBuyers(
                lbList,
                () => this.saveTractDetail(valuesClone)
            );
        } else {
            this.saveTractDetail(valuesClone);
        }
    };

    getTownships = () => {
        return this.props.getTownships(this.props.currentProject?.client?.clientNumber, this.props.currentProject?.projectNumber);
    };

    getEasternTownships = () => {
        return this.props.getEasternTownships(this.props.currentProject?.client?.clientNumber, this.props.currentProject?.projectNumber);
    };

    saveTractDetail = (formData: TractDetailFormData) => {
        this.props.saveTractDetail(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, formData);
    };

    updateTractNote = (tractDetailData: TractDetailData) => {
        this.props.updateTractNote(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, tractDetailData);
    };

    goBack = () => {
        let fieldTitle = isNaN(this.sectionNumber) ? 'maps' : 'sections';
        this.props.navigate(
            `/clients/${this.clientNumber}/projects/${this.projectNumber}/${fieldTitle}/${this.fieldNumber}/tracts`,
            this.props.location.search
        );
        this.props.clearTractDetail();
    };

    // TODO: Replace these dialogs
    hideDialog = (dialogName: string) => {
        if (dialogName === 'note') {
            this.setState({ isNoteDialogVisible: false });
        } else if (dialogName === 'ownerSearch') {
            this.setState({ isOwnerSearchDialogVisible: false });
        } else if (dialogName === 'addTract') {
            this.setState({ isAddTractDialogVisible: false });
        }
    };
    // TODO: use showDialog from props
    showDialog = (dialogName: string) => {
        if (dialogName === 'note') {
            this.setState({ isNoteDialogVisible: true });
        } else if (dialogName === 'ownerSearch') {
            this.setState({ isOwnerSearchDialogVisible: true });
        } else if (dialogName === 'addTract') {
            this.setState({ isAddTractDialogVisible: true });
        } else {
            this.props.showDialog(dialogName);
        }
    };

    // TODO, disable createHorizon on adding tract
    onCreateHorizon = (horizon: CreateHorizonDto) => {
        horizon.currentHorizonId = this.props.tractDetail.horizons[this.state.horizon].id;
        this.props.createHorizon(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, horizon);
    };

    onNavigate = (path: string) => {
        this.props.navigate(this.props.location.pathname + path, this.props.location.search);
    };

    onGetOwnerDetail = (ownerId: number, containerId: number, type: string) => {
        this.props.getOwnerDetail(this.clientNumber, this.projectNumber, ownerId, containerId, type);
    };

    onSearchOwners = (searchString: string, ownerType: string) => {
        this.props.searchOwners(this.clientNumber, this.projectNumber, searchString, ownerType);
    };

    onGetPagedOwnerships = (pageNumber: number, pagingOptions?: ODataOptions) => {
        const options = new ODataOptions();

        // TODO get page size from table config
        options.addPaging(pageNumber, 25);
        this.props.getPagedOwnerships(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, options);
    };

    sequenceHorizons = (sequence: Array<{ id: number; sequence: number }>) => {
        this.props.sequenceHorizons(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, sequence);
    };

    // Commented in case they want this back
    // onShowAddCounty = () => {
    //     this.props.showDialog(DialogList.ADD_COUNTY);
    // }

    submitAddCounty = (formData: { county: string }) => {
        const county = new County();
        county.name = formData.county;
        this.props.addCounty(this.clientNumber, this.projectNumber, county);
    };

    validateCountyForm = (formData: { county: string }) => {
        const errors: FormErrors<{ county: string }> = {};

        if (!formData.county) {
            errors.county = 'County Required';
        }

        return errors;
    };

    validate = (formValues: AnyObject) => {
        const errors: AnyObject = {};

        if (!formValues.grossAcres) {
            errors.grossAcres = 'Gross Acres is required';
        }

        if (!formValues.tractName) {
            errors.tractName = 'Tract Name is required';
        }

        return errors as FormErrors;
    };

    onSaveAddOwnership = (values: AddOwnershipData) => {
        if (!isNaN(this.sectionNumber)) {
            this.props.saveAddOwnership(this.clientNumber, this.projectNumber, this.sectionNumber, this.tractNumber, this.horizonNumber, values);
        } else {
            this.props.saveAddOwnership(this.clientNumber, this.projectNumber, this.mapNumber, this.tractNumber, this.horizonNumber, values);
        }
        this.setState({ parentOwnershipId: 0 });
    };

    addDeviation = (values: AddOwner, containerOwnerId: number, ownerType: string) => {
        this.props.addDeviation(this.clientNumber, this.projectNumber, values, containerOwnerId, ownerType);
    };

    onPromoteAdditionalOwnership = (ownershipId: number) => {
        this.props.promoteAdditionalOwnership(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.horizonNumber,
            ownershipId
        );
    };

    private updateHorizonInterval = (horizonInterval: HorizonInterval) => {
        if (horizonInterval.from.type === 'formation') {
            horizonInterval.from.custom = undefined;
            horizonInterval.from.depth = undefined;
        } else if (horizonInterval.from.type === 'depth') {
            horizonInterval.from.custom = undefined;
            horizonInterval.from.namedHorizon = undefined;
        } else if (horizonInterval.from.type === 'custom') {
            horizonInterval.from.depth = undefined;
            horizonInterval.from.namedHorizon = undefined;
        } else {
            horizonInterval.from.depth = undefined;
            horizonInterval.from.custom = undefined;
            horizonInterval.from.namedHorizon = undefined;
        }

        if (horizonInterval.to.type === 'formation') {
            horizonInterval.to.custom = undefined;
            horizonInterval.to.depth = undefined;
        } else if (horizonInterval.to.type === 'depth') {
            horizonInterval.to.custom = undefined;
            horizonInterval.to.namedHorizon = undefined;
        } else if (horizonInterval.to.type === 'custom') {
            horizonInterval.to.depth = undefined;
            horizonInterval.to.namedHorizon = undefined;
        } else {
            horizonInterval.to.depth = undefined;
            horizonInterval.to.custom = undefined;
            horizonInterval.to.namedHorizon = undefined;
        }

        horizonInterval.from.type = undefined;
        horizonInterval.to.type = undefined;

        horizonInterval.id = this.props.tractDetail.horizons[this.state.horizon].horizonInterval.id;
        this.props.updateHorizonInterval(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.props.tractDetail.horizons[this.state.horizon].horizonInterval.horizonNumber,
            horizonInterval
        );
        this.props.hideDialog();
    };

    getCloneData = (cloneHorizonData: CloneHorizon) => {
        switch (cloneHorizonData.currentLevel) {
            case 'Horizon': {
                const t = this.props.cloneTracts.filter((tract: TractDetailData) => tract.tractNumber === cloneHorizonData.tractNumber)[0];

                const his = t.horizons.map((horizon: Horizon) => {
                    const hi = HorizonInterval.from(horizon.horizonInterval);
                    hi.from.calcType();
                    hi.to.calcType();
                    return hi;
                });

                this.setState({ cloneHorizons: his });
                break;
            }
            case 'Tract': {
                this.props.getCloneTracts(this.clientNumber, this.projectNumber, cloneHorizonData.sectionNumber);
                break;
            }
            case 'Section': {
                this.props.getCloneSections(this.clientNumber, this.projectNumber, cloneHorizonData.townshipId);
                break;
            }
            case 'Township': {
                this.props.getCloneTownships(this.clientNumber, this.projectNumber);
                break;
            }
            default: {
                console.log('getCloneData - unexpected case hit');
            }
        }
    };

    onGetLeaseholds = (ownershipId: number) => {
        // this.props.getLeaseholds(this.clientNumber, this.projectNumber, this.sectionNumber, this.tractNumber, ownershipId);
        // this.props.manageLeasehold(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber, ownershipId);

        this.dialogCreators.leasehold.manageLeaseholds(ownershipId, this.horizonNumber, this.onNavigate);
    };

    onRatifyAdditionalOwner = (ownershipId: number, parentOwnershipId: number) => {
        this.dialogCreators.leasehold.ratifyaddlOwnership(ownershipId, this.horizonNumber, parentOwnershipId, this.onNavigate);
    };

    onOpenTractNotes = () => {
        this.dialogCreators.tract.openTractNotes(
            PropertyUtil.SafeGet(() => this.props.tractDetail),
            undefined,
            this.props.errorMessage,
            this.updateTractNote,
            null,
            this.props.clearError
        );
    };

    onGetLeaseholdsForDelete = (ownershipId: number) => {
        this.props.getContracts(this.clientNumber, this.projectNumber, ownershipId, false);
        this.dialogCreators.leasehold.deleteOwnership(ownershipId, this.onNavigate, () => this.confirmDelete(ownershipId));
    };

    confirmDelete = (selectedOwnershipId: number) => {
        this.onDeleteOwnership(selectedOwnershipId);
    };

    onAddAdditionalOwnership = (parentOwnershipId: number) => {
        this.setState({ parentOwnershipId: parentOwnershipId });
        this.onAddAdditionalMineralOwnership();
    };

    onAddFormation = (formation: Formation) => {
        this.props.createFormation(this.clientNumber, this.projectNumber, formation);
        this.hideSubDialog();
    };

    onDeleteOwnership = (ownershipId: number) => {
        const ownershipOptions = new ODataOptions();
        const ownershipFilter = new ODataFilter('horizonId', ODataFilterOperators.Equals, this.props.tractDetail.horizons[this.state.horizon].id);
        ownershipOptions.addFilter(ownershipFilter);

        this.props.deleteOwnership(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.horizonNumber,
            ownershipId,
            ownershipOptions
        );
    };

    onDeleteAdditionalOwnership = (ownershipId: number) => {
        this.setState({ parentOwnershipId: ownershipId });
        const owners = this.props.tractDetail.owners;
        const tract = this.props.tractDetail ? this.props.tractDetail : undefined;
        const horizonData =
            tract && tract.horizons ? tract.horizons.filter((h) => h.horizonInterval.horizonNumber === this.horizonNumber)[0] : undefined;
        const ownership = horizonData.ownership?.items?.filter((o: Ownership) => o.id === ownershipId)[0];
        if (ownership) {
            const owner = owners.filter((o: Owner) => o.ownerLookUpId === ownership.ownerLookUpId)[0];
            const ownershipOptions = new ODataOptions();
            ownershipOptions.addPaging(1, 3);
            this.dialogCreators.tract.deleteAdditionalOwnership(ownershipId, owner.name, ownership.additionalOwnerships, owners, () =>
                this.props.getPagedOwnerships(
                    this.clientNumber,
                    this.projectNumber,
                    this.fieldNumber,
                    this.tractNumber,
                    this.horizonNumber,
                    ownershipOptions
                )
            );
        }
    };

    openOwnershipNotes = (ownershipId: number) => {
        this.setState({ ownershipNotesId: ownershipId });

        const additionalOwnershipList: Array<Ownership> = new Array<Ownership>();
        PropertyUtil.SafeGet(() =>
            this.props.tractDetail.horizons[this.state.horizon].ownership.items.forEach((x) => {
                x.additionalOwnerships.forEach((y) => {
                    additionalOwnershipList.push(y);
                });
            })
        );
        const ownershipList = PropertyUtil.SafeGet(() => this.props.tractDetail.horizons[this.state.horizon].ownership.items);
        const totalList = ownershipList && additionalOwnershipList ? [...ownershipList, ...additionalOwnershipList] : undefined;
        let foundOwnership: Ownership;
        if (totalList && totalList.length > 0) {
            foundOwnership = totalList.find((x: Ownership) => x.id === this.state.ownershipNotesId);
        }
        const owners = this.props.tractDetail?.owners;
        this.dialogCreators.tract.openOwnershipNotes(foundOwnership, owners, this.props.errorMessage, 1, this.updateOwnershipNote);
    };

    openSurfaceOwnershipNotes = (ownership: Ownership, surfaceTractId: number) => {
        const owners = this.props.tractDetail?.owners;
        const updateCallback = (note: Ownership) => {
            this.props.updateOwnershipNote(
                this.clientNumber,
                this.projectNumber,
                this.fieldNumber,
                this.tractNumber,
                surfaceTractId,
                note
            );
        };
        this.dialogCreators.tract.openOwnershipNotes(
            ownership,
            owners,
            this.props.errorMessage,
            3,
            updateCallback
        );
    };

    showAddFormationDialog = () => {
        this.setState({ addFormationShowing: true });
    };

    getTractsByOwnerId = (id: number) => {
        this.props.getTractsByOwner(this.clientNumber, this.projectNumber, this.fieldNumber, id);
    };

    hideSubDialog = () => {
        this.setState({ addFormationShowing: false });
    };

    addFormationDialog = () => {
        return (
            <WrappedForm onSubmit={this.onAddFormation}>
                <FormTextBox name="name" label="Formation Name" />
                <Button type="submit" text="Add Formation" intent="primary" />
                <Button buttonStyle="link" text="Cancel" onClick={this.hideSubDialog} />
            </WrappedForm>
        );
    };

    parentOwner = () => {
        const tract = this.props.tractDetail ? this.props.tractDetail : undefined;
        const ownerships = PropertyUtil.SafeGet(() => this.props.tractDetail.horizons[this.state.horizon].ownership.items);

        const parentOwner: Owner = PropertyUtil.SafeGet(() =>
            tract.owners.find(
                (o) => o.ownerLookUpId === (ownerships as Array<Ownership>).find((op) => op.id === this.state.parentOwnershipId).ownerLookUpId
            )
        );
        return parentOwner;
    };

    deleteHorizon = (horizonNumber: string) => {
        if (
            horizonNumber === this.state.deleteHorizonText ||
            this.state.deleteHorizonText === `${this.fieldNumber}.${this.tractNumber}-${horizonNumber}`
        ) {
            this.props.deleteHorizon(this.clientNumber, this.projectNumber, this.fieldNumber, this.tractNumber, this.horizonNumber);
        }
    };

    updateDeleteHorizonText = (text: string) => {
        this.setState({ deleteHorizonText: text });
    };

    onNavigateAcquisition = (ownershipId: number, ownerLookUpId: number) => {
        // this.props.navigateAcquisition(this.clientNumber, this.projectNumber, ownerLookUpId);
        this.setState({ selectedOwnerLookUpId: ownerLookUpId });

        const owner = this.props.tractDetail.owners.find((o) => o.ownerLookUpId === ownerLookUpId);

        this.setState({ selectedOwner: owner });
        this.dialogCreators.contract.addManageAgreement(
            ownershipId,
            this.dialogCreators.hideDialog,
            this.state.selectedOwner
        );
    };

    getCityState = (zipCode: string) => {
        this.props.getCityState(zipCode);
    };

    onIncrementPage = () => {
        this.props.incrementAcqPage(this.clientNumber, this.projectNumber);
    };

    onLink = () => {
        let address = this.form.getFieldState('miscHyperlink')?.value;

        if (address) {
            const pattern = new RegExp('^(https?|ftp)://');

            if (!pattern.test(address)) {
                address = 'http://' + address;
            }

            window.open(address, '_blank');
        }
    };

    addTag = (tag: Tag) => {
        if (this.state.tags.filter((x) => x.name.trim().toLowerCase() === tag.name.trim().toLowerCase()).length === 0) {
            this.setState({ tags: [...this.state.tags, tag] });
            this.form.change('dirtySwitcher', Math.random().toString(36).substr(2, 5));
        }
    };

    deleteTag = (index: number) => {
        this.setState({ tags: this.state.tags.filter((x, i) => i !== index) });
        this.form.change('dirtySwitcher', Math.random().toString(36).substr(2, 5));
    };

    cancelFormChanges = () => {
        window.location.reload();
    };

    onOpenContactNotes = (ownership: Ownership) => {
        this.setState({ selectedSurfaceOwnership: null });
        this.setState({ selectedOwnership: ownership });
        this.dialogCreators.tract.openContactNotes(this.state.selectedOwnership, false, 'Mineral');
    };

    onOpenSurfaceContactNotes = (surfaceOwnership: Ownership) => {
        this.setState({ selectedOwnership: null });
        this.setState({ selectedSurfaceOwnership: surfaceOwnership });
        this.dialogCreators.tract.openContactNotes(this.state.selectedOwnership, false, 'Mineral');
    };

    updateTractPage = () => {
        this.props.getTractDetail(
            this.clientNumber,
            this.projectNumber,
            this.fieldNumber,
            this.tractNumber,
            this.horizonNumber,
            new ODataOptions().addPaging(1, 5)
        );
    }

    onAddMineralOwnership = () => {
        this.dialogCreators.tract.createMineralOwnership(
            'Add Ownership',
            'ADD_OWNERSHIP',
            this.addDeviation,
            this.props.navigate,
            null,
            this.onSaveAddOwnership,
            this.props.tractDetail,
            this.state.horizon,
            0
        );
    };

    onAddAdditionalMineralOwnership = () => {
        this.dialogCreators.tract.createMineralOwnership(
            `Attach Additional Ownership For: ${this.parentOwner()?.name}`,
            'ADD_ADDITIONAL_OWNERSHIP',
            this.addDeviation,
            this.onNavigate,
            null,
            this.onSaveAddOwnership,
            this.props.tractDetail,
            this.state.horizon,
            this.state.parentOwnershipId
        );
    };

    handleChange = () => {
        this.setState({ unsavedChanges: this.form.getState().dirty });
    }

    handleCounties = () => {
        switch (this.props.currentProject?.landSystemId) {
            case LandSystem.Jeffersonian:
            case LandSystem.WestTexas:
                return this.props.sectionCounties?.items;
            case LandSystem.Eastern:
                return this.props.mapCounties?.items;
            case LandSystem.EastTexas:
                return this.props.projectCounties?.items;
            default:
                return undefined;
        }
    }

    public render() {
        const tract = this.props.tractDetail ? this.props.tractDetail : undefined;
        const horizonData =
            tract && tract.horizons ? tract.horizons.filter((h) => h.horizonInterval.horizonNumber === this.horizonNumber)[0] : undefined;

        let counties: County[] = this.handleCounties();

        const selectSectionCounties = counties ? counties.map((c: County) => new SelectItem(c.id, c.name)) : undefined;

        let horizonIntervals: Array<HorizonInterval> = [];
        if (PropertyUtil.SafeGet(() => this.props.tractDetail.horizons)) {
            // tslint:disable: max-line-length
            horizonIntervals = this.props.tractDetail.horizons
                .map((hor: Horizon) => HorizonInterval.from(hor.horizonInterval))
                .sort((a: HorizonInterval, b: HorizonInterval) => a.sequencePosition - b.sequencePosition);
        }

        const cloneHorizonData = () => {
            if (this.props.tractDetail && this.props.tractDetail.horizons) {
                if (!this.cloneHorizonData) {
                    this.cloneHorizonData = new CloneHorizon();
                    this.cloneHorizonData.townshipId = this.props.tractDetail.townshipId;
                    this.cloneHorizonData.sectionNumber = this.fieldNumber;
                    this.cloneHorizonData.tractNumber = this.props.tractDetail.tractNumber;
                    this.cloneHorizonData.horizonNumber = 0;
                }

                this.cloneHorizonData.updateTownships(this.props.cloneTownships);
                this.cloneHorizonData.updateSections(this.props.cloneSections);
                this.cloneHorizonData.updateTracts(this.props.cloneTracts);
                this.cloneHorizonData.updateHorizons(this.state.cloneHorizons);

                return this.cloneHorizonData;
            }

            return undefined;
        };

        const decimalInterests = PropertyUtil.SafeGet(() =>
            horizonData.ownership.items.map((op) => {
                op.additionalOwnerships = op.additionalOwnerships?.map((aop) =>
                    Object.assign(aop, {
                        netAcres: MathUtil.cleanNumber(aop.decimalInterest * this.props.tractDetail.grossAcres),
                        decimalInterest: MathUtil.cleanNumber(aop.decimalInterest, 10, 0)
                    })
                );

                return Object.assign(op, {
                    contactCategoryId: this.props.ownershipContactCategories.categories.filter((x) => x.name === op.contactCategory)[0]?.id,
                    netAcres: MathUtil.cleanNumber(op.decimalInterest * this.props.tractDetail.grossAcres),
                    decimalInterest: MathUtil.cleanNumber(op.decimalInterest, 10, 0)
                });
            })
        );

        const orderedHistories = horizonData?.horizonExaminedHistory?.sort((a, b) => (new Date(a.takeOffDate) > new Date(b.takeOffDate) ? -1 : 1));
        const examinedHistory = orderedHistories?.[0];
        let lastExamined = '';
        if (examinedHistory) {
            if (examinedHistory?.recordTypeId === 1) {
                lastExamined = `Book ${examinedHistory.book || '[n/a]'}, Page ${orderedHistories[0].page || '[n/a]'}`;
            } else if (examinedHistory?.recordTypeId === 2) {
                lastExamined = `Inst# ${examinedHistory?.instrumentNumber || '[n/a]'}`;
            } else {
                lastExamined = '[n/a]';
            }
        }

        const warningStyle: React.CSSProperties = {
            display: 'inline-block',
            padding: '0.5rem',
            margin: '0 0 1rem 0',
            fontWeight: 700,
            background: '#d5d5d5',
            fontSize: '.8em',
            color: '#565656',
            width: '100%',
            textAlign: 'center',
            borderRadius: '0.4rem',
        };

        this.initialValues = {
            tractNumber: PropertyUtil.SafeGet(() => tract.tractNumber),
            horizonId: PropertyUtil.SafeGet(() => horizonData.id),
            tractId: PropertyUtil.SafeGet(() => horizonData.tractId),
            horizonName: PropertyUtil.SafeGet(() => horizonData.horizonName),
            horizonBeginDepth: PropertyUtil.SafeGet(() => horizonData.horizonBeginDepth),
            horizonEndDepth: PropertyUtil.SafeGet(() => horizonData.horizonEndDepth),
            tractName: PropertyUtil.SafeGet(() => tract.tractName),
            grossAcres: PropertyUtil.SafeGet(() => MathUtil.cleanNumber(tract.grossAcres)),
            countyId: PropertyUtil.SafeGet(() => tract.countyId),
            legalDescription: PropertyUtil.SafeGet(() => tract.legalDescription),
            shortLegalDescription: PropertyUtil.SafeGet(() => tract.shortLegalDescription),
            sourceReference: PropertyUtil.SafeGet(() => horizonData.sourceReference),
            sourceDate:
                horizonData && horizonData.sourceDate
                    ? PropertyUtil.SafeGet(() => moment(horizonData.sourceDate, 'MM/DD/YYYY').format('YYYY-MM-DD'))
                    : null,
            // instrumentType: PropertyUtil.SafeGet(() => horizonData.instrumentType),
            instrumentTypeId: PropertyUtil.SafeGet(() => horizonData.instrumentTypeId),
            source: PropertyUtil.SafeGet(() => horizonData.source),
            grantor: PropertyUtil.SafeGet(() => horizonData.grantor),
            grantee: PropertyUtil.SafeGet(() => horizonData.grantee),
            modifiedBy: PropertyUtil.SafeGet(() => horizonData.modifiedByName),
            modifiedDate: PropertyUtil.SafeGet(() => moment(horizonData.modifiedDate).format('MM-DD-YYYY hh:mm a')),
            createdBy: PropertyUtil.SafeGet(() => horizonData.createdByName),
            createdDate: PropertyUtil.SafeGet(() => moment(horizonData.createdDate).format('MM-DD-YYYY hh:mm a')),
            examinedByLandman: examinedHistory?.examinedByLandman,
            // lastExamined: PropertyUtil.SafeGet(() => horizonData.lastExamined),
            lastExamined: lastExamined,
            takeOffDate: PropertyUtil.SafeGet(() => examinedHistory?.takeOffDate.toString() === '0001-01-01T00:00:00+00:00')
                ? null
                : PropertyUtil.SafeGet(() => moment(examinedHistory.takeOffDate).format('MM/DD/YYYY')),
            examinedDate: PropertyUtil.SafeGet(() => examinedHistory?.examinedDate.toString() === '0001-01-01T00:00:00+00:00')
                ? null
                : PropertyUtil.SafeGet(() => moment(examinedHistory.examinedDate).format('MM/DD/YYYY')),

            ownershipType: PropertyUtil.SafeGet(() => horizonData.ownershipType),
            sectionId: PropertyUtil.SafeGet(() => this.state.section),
            ownerships: decimalInterests,
            examinationTypeId: PropertyUtil.SafeGet(() => tract.examinationTypeId),
            miscHyperlink: horizonData?.miscHyperlink,
            eastTexasAbstractIds: tract?.eastTexasAbstractIds,
            parcelID: PropertyUtil.SafeGet(() => tract.parcelID),
            boundedByNorth: PropertyUtil.SafeGet(() => tract.boundedByNorth),
            boundedByEast: PropertyUtil.SafeGet(() => tract.boundedByEast),
            boundedBySouth: PropertyUtil.SafeGet(() => tract.boundedBySouth),
            boundedByWest: PropertyUtil.SafeGet(() => tract.boundedByWest)
        };

        // TODO: Fix this up.
        const onOpenHorizonDialog = (dialogParams: IHorizonSectionProps) => {
            this.setState({ dialogParams: dialogParams });
            this.props.showDialog(DialogList.ADD_HORIZON);
        };

        const navigateToRunsheetRecord = () => {
            this.props.navigate(`/clients/${this.clientNumber}/projects/${this.projectNumber}/runsheets/${tract.horizons[0].tractId}`);
        };

        interface IShortLegalDescription {
            countyId: number;
            parcelID: string;
            boundedByNorth: string;
            boundedByEast: string;
            boundedByWest: string;
            boundedBySouth: string;
            grantor: string;
            instrumentTypeId: number;
            sourceDate: string;
            sourceReference: string;
            grossAcres: string;
        }

        const onGenerateShortLegalDescription = async () => {
            let formValues = (this.form ? this.form.getState().values : {}) as IShortLegalDescription;

            let townshipName = '[Township Name]';
            let townshipInfo = undefined;

            if (this.props.currentProject?.landSystemId === LandSystem.Eastern) {
                townshipInfo = this.props.easternTownship?.name;
                townshipName = townshipInfo || '[Township Name]';

            } else {
                townshipInfo = (this.props.tractDetail ? 'T' + this.props.tractDetail?.township + ' R' + this.props.tractDetail?.range : undefined);
                townshipName = townshipInfo || '[Township Name]';
            }

            let selectedCounty = selectSectionCounties?.find((c) => c.id === formValues.countyId);
            let countyName = selectedCounty?.name || '[County]';
            let state = this.props.currentProject?.state?.name || '[State]';
            let parcelID = formValues.parcelID || '[Parcel Id]';
            let boundedByNorth = formValues.boundedByNorth || '[Bounded By North]';
            let boundedByEast = formValues.boundedByEast || '[Bounded By East]';
            let boundedBySouth = formValues.boundedBySouth || '[Bounded By South]';
            let boundedByWest = formValues.boundedByWest || '[Bounded By West]';
            let grantor = formValues.grantor || '[Grantor]';

            let selectedInstrumentType = formValues.instrumentTypeId ? convertInstrumentTypesToSelectList()[formValues.instrumentTypeId - 1] : undefined;
            let deedInstrumentType = selectedInstrumentType?.name || '[Deed Instrument Type]';

            let deedDate = formValues.sourceDate || '[Deed Date]';
            let deedReference = formValues.sourceReference || '[Deed Reference]';
            let grossAcres = formValues.grossAcres || '[Gross Acres]';

            let shortLegalDescription =
                'The Leasehold is located, all or in part, in Township of ' + townshipName +
                ' in the County of ' + countyName +
                ', in the State of ' + state + ', and is bounded substantially, formerly or currently as follows:\n\n' +

                'Property Tax Identification Number: ' + parcelID + '\n' +
                'and is bounded formerly and currently as follows: ' + '\n' +
                '\tOn the North by lands now or formerly of ' + boundedByNorth + '\n' +
                '\tOn the East by lands now or formerly of ' + boundedByEast + '\n' +
                '\tOn the South by lands now or formerly of ' + boundedBySouth + '\n' +
                '\tOn the West by lands now or formerly of ' + boundedByWest + '\n\n' +

                'including lands acquired from ' + grantor +
                ', by virtue of ' + deedInstrumentType +
                ' dated ' + deedDate +
                ', recorded in ' + deedReference +
                ', described for the purposes of this agreement as containing a total of ' + grossAcres +
                ' Leasehold acres, whether actually more or less, and including contiguous lands owned by Lessor.';

            this.form.change('shortLegalDescription', shortLegalDescription);
        };

        return (
            <div className="tract-detail">
                {/* MAGIC BREAK. THE CSS GODS REQUIRE IT. NO TOUCHY. */}
                <br />

                <div className="tract-nav">
                    {!isNaN(this.sectionNumber) && (
                        <h2 style={{ marginRight: '.7rem', fontWeight: 'lighter', marginLeft: '2rem' }}>
                            {`Global ID: ${this.clientNumber}.${this.projectNumber}.${this.sectionNumber}.${this.tractNumber}-${this.horizonNumber}`}
                        </h2>
                    )}

                    {!isNaN(this.mapNumber) && (
                        <h2 style={{ marginRight: '.7rem', fontWeight: 'lighter', marginLeft: '2rem' }}>
                            {`Global ID: ${this.clientNumber}.${this.projectNumber}.${this.mapNumber}.${this.tractNumber}-${this.horizonNumber}`}
                        </h2>
                    )}
                </div>

                <HorizonSection
                    selectedHorizon={
                        this.props.tractDetail && this.props.tractDetail.horizons ? this.props.tractDetail.horizons[this.state.horizon] : undefined
                    }
                    horizons={PropertyUtil.SafeGet(() => this.props.tractDetail.horizons)}
                    horizonNumber={this.horizonNumber}
                    formations={this.props.formations}
                    cloneHorizonData={cloneHorizonData()}
                    onGetData={(val) => this.getCloneData(val)}
                    uniqueHorizonIntervals={this.props.uniqueHorizonIntervals}
                    onChangeHorizon={this.changeHorizon}
                    showDialog={this.showDialog}
                    currentTract={this.props.tractDetail}
                    currentClientNumber={this.clientNumber}
                    currentProjectNumber={this.projectNumber}
                    sequenceHorizons={this.sequenceHorizons}
                    onCreateHorizon={this.onCreateHorizon}
                    onCreateFormation={this.onAddFormation}
                    initializeOwnershipList={this.props.initializeOwnershipList}
                    idVerificationMessage={this.props.idVerificationMessage}
                    idVerificationResult={this.props.idVerificationResult}
                    setVerificationMessage={this.props.setVerificationMessage}
                    verifyId={this.props.verifyId}
                    navigate={this.props.navigate}
                    onOpenHorizonDialog={(dialogParams: IHorizonSectionProps) => onOpenHorizonDialog(dialogParams)}
                    unsavedChanges={this.state.unsavedChanges}
                />

                <div className="tract-info-form">
                    {this.props.tractDetail && (
                        <Form
                            onSubmit={this.onSubmit}
                            keepDirtyOnReinitialize={true}
                            mutators={{ ...arrayMutators }}
                            initialValues={this.initialValues}
                            validate={this.validate}
                            // Only re-render this whole form subtree (every ownership card) when
                            // these top-level flags change — NOT on every keystroke. The body uses
                            // submitting/pristine and reads dirty via form.getState(); individual
                            // Fields subscribe to their own values independently.
                            subscription={{ submitting: true, pristine: true, dirty: true }}
                            render={({ handleSubmit, form, submitting, pristine }) => {
                                this.form = form;

                                return (
                                    <form onSubmit={handleSubmit} id="tractDetailForm">
                                        {this?.form?.getState()?.dirty && (
                                            <>
                                                <div
                                                    id="dirtyFlag"
                                                    style={{
                                                        position: 'fixed',
                                                        top: '4.7rem',
                                                        left: '0',
                                                        width: '100%',
                                                        color: 'white',
                                                        backgroundColor: 'rgba(191, 195, 203, .7)',
                                                        zIndex: 9000,
                                                        padding: '1rem 0',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        borderTop: '10px solid rgba(66, 184, 241, 1)',
                                                    }}
                                                >
                                                    <div>Unsaved Changes - Please Save Before Leaving Form</div>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            right: '.5rem',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            display: 'flex',
                                                        }}
                                                    >
                                                        <div>
                                                            <Button text="Save" type="submit" size="small" intent="primary" disabled={submitting} />
                                                        </div>
                                                        <div style={{ margin: '0 1rem', borderRight: '1px solid white', width: '1px' }} />
                                                        <Button
                                                            text="Cancel Changes"
                                                            size="small"
                                                            disabled={pristine || submitting}
                                                            onClick={this.cancelFormChanges}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className="clearfix tract-data">
                                            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                                                <legend className="legend">Tract Information</legend>
                                            </fieldset>

                                            <div className="entry-history" style={{ marginBottom: '1.5rem' }}>
                                                <>
                                                    <label className="readonly-label">Created By:
                                                        <span className="readonly-field">{this.props.tractDetail.tractCreatedByName || 'Unknown Creator'}</span>
                                                    </label>

                                                    <label className="readonly-label">Created Date:
                                                        <span className="readonly-field">
                                                            {this.props.tractDetail.createdDate ?
                                                                moment(this.props.tractDetail.createdDate).format('MM-DD-YYYY hh:mm a') :
                                                                'Unknown Date'
                                                            }
                                                        </span>
                                                    </label>

                                                    <label className="readonly-label">Modified By:
                                                        <span className="readonly-field">{this.props.tractDetail.tractModifiedByName || 'Unknown Modifier'}</span>
                                                    </label>

                                                    <label className="readonly-label">Modified Date:
                                                        <span className="readonly-field">
                                                            {this.props.tractDetail.modifiedDate ?
                                                                moment(this.props.tractDetail.modifiedDate).format('MM-DD-YYYY hh:mm a') :
                                                                'Unknown Date'
                                                            }
                                                        </span>
                                                    </label>
                                                </>
                                                <span style={{ paddingRight: '1rem', position: 'relative', float: 'right' }}>
                                                    <Button
                                                        intent="primary"
                                                        text="Tract Notes"
                                                        onClick={() => this.onOpenTractNotes()}
                                                        size="medium"
                                                        disabled={this.form?.getState()?.dirty}
                                                    />
                                                </span>
                                            </div>
                                            <FormRow className="row">
                                                <FormTextBox name="grossAcres" label="Gross Acres" isRequired={true} onChange={this.handleChange} />
                                                <FormSelect name="countyId" items={selectSectionCounties} label="County" onChange={this.handleChange} />
                                                <FormTextBox name="sourceReference" label="Deed Reference" onChange={this.handleChange} />
                                                <FormTextBox name="sourceDate" type={FormTextBoxDataType.Date} label="Deed Date" onChange={this.handleChange} />
                                                <FormSelect
                                                    name="instrumentTypeId"
                                                    items={convertInstrumentTypesToSelectList()}
                                                    label="Instrument Type"
                                                    onChange={this.handleChange}
                                                />
                                                <FormTextBox name="source" label="Inst. Source" onChange={this.handleChange} />
                                            </FormRow>
                                            <FormRow className="row">
                                                <FormTextBox name="tractName" label="Tract Name" isRequired={true} onChange={this.handleChange} />
                                                <FormTextBox name="parcelID" label="Parcel ID" onChange={this.handleChange} />
                                                <FormTextBox style={{ width: '39%' }} name="grantor" label="Grantor" onChange={this.handleChange} />
                                                <FormTextBox style={{ width: '39%' }} name="grantee" label="Grantee" onChange={this.handleChange} />
                                            </FormRow>
                                            <FormTextArea name="legalDescription" label="Legal Description" resize="vertical" height="10.6rem" onChange={this.handleChange} />
                                            <FormTextArea name="shortLegalDescription" label="Short Legal Description" resize="vertical" height="10.6rem" onChange={this.handleChange} />
                                            <FormRow className="row">
                                                <FormTextBox name="boundedByNorth" label="Bounded By North" onChange={this.handleChange} />
                                                <FormTextBox name="boundedByEast" label="Bounded By East" onChange={this.handleChange} />
                                                <FormTextBox name="boundedBySouth" label="Bounded By South" onChange={this.handleChange} />
                                                <FormTextBox name="boundedByWest" label="Bounded By West" onChange={this.handleChange} />
                                                <Button
                                                    intent="primary"
                                                    text="Generate Short Legal Description"
                                                    size="medium"
                                                    style={{ marginLeft: 'auto' }}
                                                    onClick={onGenerateShortLegalDescription}
                                                />
                                            </FormRow>
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ width: '65%', display: 'flex', marginRight: '1rem' }}>
                                                    <div className="react-tags__label">Tags</div>
                                                    <ReactTags
                                                        ref={this.tagsRef}
                                                        tags={this.state.tags}
                                                        onAddition={this.addTag}
                                                        onDelete={this.deleteTag}
                                                        allowNew={true}
                                                        tagComponent={TagComponent}
                                                        suggestions={this.props.projectTags}
                                                        allowBackspace={false}
                                                    />
                                                </div>
                                                <FormTextBox style={{ width: '30%' }} name="miscHyperlink" label="Misc Hyperlink" onChange={this.handleChange} />
                                                <div style={{ position: 'relative', marginLeft: '1rem', top: '-0.5rem' }}>
                                                    <Button
                                                        style={{ marginBottom: '1.75rem', position: 'absolute', bottom: '0' }}
                                                        text="Link"
                                                        onClick={this.onLink}
                                                    />
                                                </div>
                                            </div>

                                            {/* Used to trigger dirty state, no output to screen */}
                                            <Field name="dirtyEastTexasAbstracts">{() => <></>}</Field>
                                            <Field name="dirtySwitcher">{() => <></>}</Field>
                                            {this.props.currentProject?.landSystemId === LandSystem.EastTexas && (
                                                <EastTexasSurveyPanel counties={selectSectionCounties} formApi={form} />
                                            )}

                                            <TractDetailDocs
                                                showDialog={this.props.showDialog}
                                                hideDialog={this.props.hideDialog}
                                                hasOwnership={PropertyUtil.SafeGet(() =>
                                                (this.props.ownerships?.items
                                                    ? this.props.ownerships.items.length > 0
                                                    : this.props.tractDetail?.horizons[this.state.horizon]?.ownership?.items?.length > 0
                                                )
                                                )}
                                                tractType="Mineral"
                                                horizonId={PropertyUtil.SafeGet(() => this.props.tractDetail.horizons[this.state.horizon].id)}
                                            />

                                            {!this.props.testMode && (
                                                <>
                                                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginTop: '1rem' }}>
                                                        <legend className="legend">Title Examination History</legend>
                                                    </fieldset>
                                                    {/* <div style={{ fontSize: '1.3em' }}>Last Recorded Examination</div> */}
                                                    <FormRow>
                                                        <label className="form-label mr-2">
                                                            <b>Report Date:</b>
                                                            <Field name="examinedDate">
                                                                {({ input }) => <span className="readonly-field">{input.value}</span>}
                                                            </Field>
                                                        </label>
                                                        <label className="form-label mr-2">
                                                            <b>Examined By:</b>
                                                            <Field name="examinedByLandman">
                                                                {({ input }) => <span className="readonly-field">{input.value}</span>}
                                                            </Field>
                                                        </label>

                                                        <label className="form-label mr-2">
                                                            <b>Last Examined:</b>
                                                            <Field name="lastExamined">
                                                                {({ input }) => <span className="readonly-field">{input.value}</span>}
                                                            </Field>
                                                        </label>

                                                        <label className="form-label mr-2">
                                                            <b>Certification Date:</b>
                                                            <Field name="takeOffDate">
                                                                {({ input }) => <span className="readonly-field">{input.value}</span>}
                                                            </Field>
                                                        </label>

                                                        <label className="form-label mr-2">
                                                            <b>Examination Type:</b>
                                                            <Field name="ownershipType">
                                                                {({ input }) => <span className="readonly-field">{input.value}</span>}
                                                            </Field>
                                                        </label>
                                                    </FormRow>
                                                    <div style={{ display: 'flex', margin: '3rem 0 1.5rem 0' }}>
                                                        <Button
                                                            intent="primary"
                                                            onClick={() => this.showDialog(DialogList.EXAMINED_HISTORY)}
                                                            text="Manage Title Examination History"
                                                            size="medium"
                                                            style={{ marginRight: '1rem' }}
                                                            disabled={this.form.getState().dirty}
                                                        />
                                                        {this.state.rerender && <Button
                                                            id={`animatedRunsheetButton`}
                                                            intent="primary"
                                                            type="button"
                                                            className="animated-runsheet-button"
                                                            onClick={navigateToRunsheetRecord}
                                                            text="Runsheet Routing"
                                                            size="medium"
                                                            style={{ marginLeft: '1rem' }}
                                                        />}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="ownership-breakdown">
                                            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                                <legend className="legend">Mineral Ownership Information</legend>
                                            </fieldset>
                                            <span style={warningStyle}>ALL INTEREST REPRESENTED AS DECIMAL</span>
                                            {/* {!isNaN(this.sectionNumber) && ( */}
                                            <OwnershipList
                                                initOwnerTracts={this.props.initializeOwnerTracts}
                                                clientNumber={this.clientNumber}
                                                projectNumber={this.projectNumber}
                                                project={this.props.currentProject}
                                                fieldNumber={this.fieldNumber}
                                                tractNumber={this.tractNumber}
                                                horizonNumber={this.horizonNumber}
                                                horizon={this.state.horizon}
                                                promoteAdditionalOwnership={this.onPromoteAdditionalOwnership}
                                                form={form}
                                                leaseholds={this.props.leaseholds}
                                                ownershipContactCategories={PropertyUtil.SafeGet(
                                                    () => this.props.ownershipContactCategories.categories
                                                )}
                                                navigate={this.onNavigate}
                                                showOwnerSearch={this.showDialog}
                                                setDialogShowing={this.props.showDialog}
                                                getLeaseholds={this.onGetLeaseholds}
                                                ratifyAdditionalOwner={this.onRatifyAdditionalOwner}
                                                getLeaseholdsByTract={this.props.getLeaseholdsByTract}
                                                getLeaseholdsForDelete={this.onGetLeaseholdsForDelete}
                                                hideDialog={this.props.hideDialog}
                                                addAdditionalOwnership={this.onAddAdditionalOwnership}
                                                deleteOwnership={this.onDeleteOwnership}
                                                totalInterest={PropertyUtil.SafeGet(() => this.props.tractDetail.totalInterest)}
                                                executiveRights={PropertyUtil.SafeGet(() => this.props.tractDetail.executiveRights)}
                                                grossAcres={PropertyUtil.SafeGet(() => this.props.tractDetail.grossAcres)}
                                                projectStaff={this.props.projectStaff}
                                                errorMessage={this.props.errorMessage}
                                                clearError={this.props.clearError}
                                                openOwnershipNotes={this.openOwnershipNotes}
                                                hasNonExecutiveAdditionalOwnership={this.props.tractDetail.nonExecutiveAdditionalOwnershipExists}
                                                idVerificationMessage={this.props.idVerificationMessage}
                                                idVerificationResult={this.props.idVerificationResult}
                                                clearVerification={this.props.clearVerification}
                                                setVerificationMessage={this.props.setVerificationMessage}
                                                cloneData={this.props.cloneData}
                                                navigateAcquisition={this.onNavigateAcquisition}
                                                deleteAdditionalOwnership={this.onDeleteAdditionalOwnership}
                                                openContactNotes={this.onOpenContactNotes}
                                                onAddOwnership={this.onAddMineralOwnership}
                                                resetForm={(ownerships: PagedResultSet<Ownership>) => this.props.registerOwnerships(ownerships, this.horizonNumber)}
                                            />
                                        </div>
                                        <div>
                                            <SurfaceOwnershipList
                                                landSystem={this.landSystem}
                                                ref={this.surfaceOwnershipsRef}
                                                isFormDirty={this.form?.getState()?.dirty}
                                                ownershipContactCategories={PropertyUtil.SafeGet(
                                                    () => this.props.ownershipContactCategories.categories
                                                )}
                                                categoryTypes={this.props.currentProject?.ownershipCategoryTypes}
                                                counties={counties}
                                                makeDirty={() => this.form?.change('dirtySwitcher', Math.random().toString(36).substr(2, 5))}
                                                openContactNotes={this.onOpenSurfaceContactNotes}
                                                updateTractPage={this.updateTractPage}
                                                projectStaff={this.props.projectStaff}
                                                openOwnershipNotes={this.openSurfaceOwnershipNotes} 
                                            />
                                            {/* {!isNaN(this.mapNumber) && (
                                                <>
                                                // @ts-nocheck
                                                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                                        <legend className="legend">Surface Ownership Information</legend>
                                                    </fieldset>
                                                    <div style={{ fontWeight: 'bold', color: 'red' }}>Currently Disabled</div>
                                                    <div style={{ textAlign: 'right', marginRight: '1rem' }}>
                                                        <Button text="Add Surface Parcel" size="medium" intent="primary" onClick={() => window.alert('Currently Disabled')} />
                                                    </div>
                                                    <CardContainer>
                                                        <Card badge={'875'}>
                                                            <div style={{ padding: '1rem', boxSizing: 'border-box' }}>
                                                                <FormRow>
                                                                    <FormTextBox
                                                                        label="Parcel"
                                                                        name={`parcel`}
                                                                        style={{ width: '30%' }}
                                                                    />
                                                                    <FormTextBox
                                                                        label="Acres"
                                                                        name={`acres`}
                                                                        style={{ width: '30%' }}
                                                                    />
                                                                    <FormCheckbox label="Partial" name="partial" wrapped={true} style={{ width: '18.4%' }} />
                                                                </FormRow>
                                                                <FormRow>
                                                                    <FormTextBox name="so[0]grantor" label="Grantor" style={{ width: '40%' }} />
                                                                    <FormTextBox name="so[0]grantee" label="Grantee" style={{ width: '40%' }} />
                                                                </FormRow>
                                                                <FormRow>
                                                                    <FormSelect
                                                                        items={[]}
                                                                        label="Inst. Type"
                                                                        name={`instrumentType`}
                                                                        style={{ width: '25%' }}
                                                                    />
                                                                    <FormTextBox
                                                                        label="Book/Doc"
                                                                        name={`bookDoc`}
                                                                        style={{ width: '25%' }}
                                                                    />
                                                                    <FormTextBox
                                                                        label="Page"
                                                                        name={`page`}
                                                                        style={{ width: '25%' }}
                                                                    />
                                                                    <FormTextBox
                                                                        label="Date"
                                                                        name={`date`}
                                                                        style={{ width: '25%' }}
                                                                    />
                                                                </FormRow>
                                                                <FormRow className="row">
                                                                    <FormTextBox isDisabled={true} name="boundByNorth" label="Bound By North" style={{ width: '25%' }} />
                                                                    <FormTextBox isDisabled={true} name="boundBySouth" label="Bound By South" style={{ width: '25%' }} />
                                                                    <FormTextBox isDisabled={true} name="boundByEast" label="Bound By East" style={{ width: '25%' }} />
                                                                    <FormTextBox isDisabled={true} name="boundByWest" label="Bound By West" style={{ width: '25%' }} />
                                                                </FormRow>
                                                                <hr />
                                                                <div>
                                                                    <div style={{ float: 'left' }}>
                                                                        <div><span style={{ fontSize: '1.1em' }}>Owner Name</span><br />Address</div>
                                                                    </div>
                                                                    <div style={{ float: 'right' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <div className="mr-1">
                                                                                <FormTextBox
                                                                                    label="Interest"
                                                                                    name={`so[0][0].decimalInterest`}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <FormTextBox
                                                                                    label="Net Acres"
                                                                                    name={`so[0][0]ownerships[0].netAcres`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div style={{ clear: 'both' }} />
                                                            </div>
                                                        </Card>
                                                    </CardContainer>
                                                </>
                                            )} */}
                                        </div>

                                        <div style={{ textAlign: 'right', margin: '1rem 1rem .7rem 0' }}>
                                            <Button text="Save" type="submit" size="medium" intent="primary" disabled={submitting} />{' '}
                                            <Button text="Cancel" size="medium" disabled={pristine || submitting} onClick={form.reset} />
                                        </div>
                                    </form>
                                );
                            }}
                        />
                    )}
                </div>

                {/* <PDFWindow>
                    <TractMorReport />
                </PDFWindow> */}

                <Dialog
                    title="Edit Horizon"
                    dialogName={DialogList.EDIT_HORIZON}
                    subDialogHeader="Add Formation"
                    subDialogShowing={this.state.addFormationShowing}
                    subDialog={this.addFormationDialog}
                >
                    <HorizonIntervalComponent
                        formations={this.props.formations}
                        showAddFormationPanel={this.showAddFormationDialog}
                        horizonInterval={horizonData && horizonData.horizonInterval}
                        updateHorizonInterval={this.updateHorizonInterval}
                        onNext={(horizonInterval: HorizonInterval) => this.updateHorizonInterval(horizonInterval)}
                        onPrev={() => undefined}
                    />
                </Dialog>

                {/* Need better error handling and formatting of the dialog */}
                <DeleteConfirmDialog
                    title="Delete Horizon"
                    promptText="Type Horizon number to confirm delete"
                    dialogName={DialogList.DELETE_HORIZON}
                    delete={this.deleteHorizon}
                    item={this.horizonNumber ? this.horizonNumber.toString() : ''}
                    updateText={this.updateDeleteHorizonText}
                    errorMessage={this.props.errorMessage}
                    onCloseDialog={this.props.clearError}
                />

                <Dialog title="Sequence Horizons" dialogName={DialogList.SEQUENCE_HORIZONS}>
                    <HorizonSequencingComponent horizons={horizonIntervals} sequenceHorizons={this.sequenceHorizons} customDetailFormat={(item) => <div>{item.toString()}</div>} />
                </Dialog>

                <ExaminedHistoryDialog
                    dialogName={DialogList.EXAMINED_HISTORY}
                    hideDialog={this.props.hideDialog}
                    examinedHistory={PropertyUtil.SafeGet(() => this.props.tractDetail.horizons[this.state.horizon].horizonExaminedHistory)}
                    onSaveExaminedHistory={this.onSaveExaminedHistory}
                    horizonId={PropertyUtil.SafeGet(() => this.props.tractDetail.horizons[this.state.horizon].id)}
                />

                <Dialog dialogName={DialogList.ADD_COUNTY} title={'Add County'}>
                    <WrappedForm onSubmit={this.submitAddCounty} validate={this.validateCountyForm}>
                        <Textbox name="county" label="County Name" />
                    </WrappedForm>
                </Dialog>

                <ManageLeaseholdDialog
                    clientNumber={this.clientNumber}
                    projectNumber={this.projectNumber}
                    sectionNumber={this.fieldNumber}
                    tractNumber={this.tractNumber}
                    horizonNumber={this.horizonNumber}
                    leaseholds={this.props.tractLeaseholds?.filter((lh: Leasehold) => lh.isActiveLease === true)}
                    hideDialog={this.props.hideDialog}
                    errorMessage={this.props.errorMessage}
                    clearError={this.props.clearError}
                    updateLeasehold={this.props.updateLeasehold}
                />

                <OwnerListFilter applyFilter={this.onGetPagedOwnerships} />

                <ManageAgreementDialog
                    agreements={this.props.agreements}
                    clientNumber={this.clientNumber}
                    projectNumber={this.projectNumber}
                    navigate={this.props.navigate}
                    ownerLookUpId={this.state.selectedOwnerLookUpId}
                    owner={this.state.selectedOwner}
                    incrementPage={this.onIncrementPage}
                />

                <CreateHorizonDialog {...this.state.dialogParams} onCloseDialog={() => this.props.hideDialog()} />
            </div>
        );
    }
}

const mapStateToProps = (state: IRootState): ITractDetailStoreProps => ({
    currentProject: state.project.currentProject,
    sectionCounties: selectors.county.sectionCounties(state),
    projectCounties: state.county.projectCounties,
    mapCounties: state.county.easternMapCounties,
    tractDetail: selectors.tract.tractDetail(state),
    formations: selectors.tract.formations(state),
    uniqueHorizonIntervals: selectors.tract.uniqueHorizonIntervals(state),
    selectedCounty: selectors.county.selectedCounty(state),
    searchOwnersResults: selectors.tract.searchOwnersResults(state),
    cloneTracts: state.tract.cloneTracts,
    cloneSections: state.tract.cloneSections,
    cloneTownships: state.tract.cloneTownships,
    cloneTract: state.tract.cloneTract,
    leaseholds: state.leasehold.leaseholds,
    tractLeaseholds: state.leasehold.tractLeaseholds,
    ownerDetails: selectors.owner.ownerDetailsSelector(state),
    ownerships: selectors.tract.ownershipsSelector(state),
    ownershipPageConfig: selectors.tract.ownershipPageConfig(state),
    states: selectors.state.states(state),
    testMode: state.layout.testingMode,
    ownershipContactCategories: state.ownershipContactCategories.categories,
    projectStaff: state.projectStaffing.staffing,
    errorMessage: selectors.tract.error(state),
    phoneNumberTypes: selectors.phoneNumberType.phoneNumberTypes(state),
    ownerTracts: state.tract.ownerTracts,
    idVerificationMessage: state.search.verifyIdResult,
    idVerificationResult: state.search.idExists,
    agreements: selectors.leaseGeneration.leaseGenerationFormCollection(state),
    uspsCityState: state.tract.uspsCityState,
    projectTags: state.tags.tags,
    townships: state.tract.townships,
    easternTownships: state.tract.easternTownships,
    township: state.tract.township,
    easternTownship: state.tract.easternTownship,
    easternMap: state.tract.easternMap,
});

const mapDispatchToProps: ITractDetailDispatchProps = {
    getCityState: (zipCode: string) => actions.tract.getCityState(zipCode),
    navigate: (path: string, search?: string) => push({ pathname: path, search }),
    getPhoneNumberTypes: () => actions.phoneNumberType.getPhoneNumberTypes(),
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
    hideDialog: () => actions.layout.hideDialog(),
    clearTractDetail: () => actions.tract.clearTractDetail(),
    clearError: () => actions.tract.clearError(),
    initializeTractsPage: () => actions.tract.initTractPage(),
    getTractDetail: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number) => actions.tract.getTractDetail(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, undefined),
    deleteHorizon: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number) => actions.tract.deleteHorizon(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber),

    getCloneTracts: (clientNumber: number, projectNumber: number, sectionNumber: number) => actions.tract.getCloneTracts(clientNumber, projectNumber, sectionNumber),
    getCloneSections: (clientNumber: number, projectNumber: number, townshipId: number) => actions.tract.getCloneSections(clientNumber, projectNumber, townshipId),
    getCloneTownships: (clientNumber: number, projectNumber: number) => actions.tract.getCloneTownships(clientNumber, projectNumber),
    getCloneTractDetail: (clientNumber: number, projectNumber: number, sectionNumber, tractNumber: number) => actions.tract.getCloneTractDetail(clientNumber, projectNumber, sectionNumber, tractNumber),
    saveTractDetail: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        formValues: TractDetailFormData
    ) => actions.tract.saveTractDetail(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, formValues),
    createHorizon: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizon: CreateHorizonDto) => actions.tract.createHorizon(clientNumber, projectNumber, sectionNumber, tractNumber, horizon),
    saveExaminedHistory: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        examinedHistoryChanges: ExaminedHistoryChanges
    ) => actions.tract.saveExaminedHistory(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, examinedHistoryChanges),
    getOwnerDetail: (clientNumber: number, projectNumber: number, ownerId: number, containerId: number, type: string) => actions.owner.getOwnerDetails(clientNumber, projectNumber, ownerId, containerId, type),
    saveAddOwnershipCollection: (clientNumber: number, projectNumber: number, addOwnershipCollection: AddOwnershipCollection) => actions.tract.saveAddOwnershipCollection(clientNumber, projectNumber, addOwnershipCollection),
    addDeviation: (clientNumber: number, projectNumber: number, addOwnership: AddOwner, containerOwnerId: number, ownerType: string) => actions.owner.addDeviation(clientNumber, projectNumber, addOwnership, containerOwnerId, ownerType),
    createTract: (clientNumber: number, projectNumber: number, sectionNumber: number, values: NewTract) => actions.tract.createTract(clientNumber, projectNumber, sectionNumber, values),
    searchOwners: (clientNumber: number, projectNumber: number, searchText: string, ownerType: string) => actions.tract.getSearchOwners(clientNumber, projectNumber, searchText, ownerType),
    getPagedOwnerships: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions
    ) => actions.tract.getPagedOwnerships(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, options),
    getTractsByOwner: (clientNumber: number, projectNumber: number, sectionNumber: number, ownerId: number) => actions.tract.getTractsByOwner(clientNumber, projectNumber, sectionNumber, ownerId),
    getFormations: (clientNumber: number, projectNumber: number) => actions.tract.getFormations(clientNumber, projectNumber),
    createFormation: (clientNumber: number, projectNumber: number, formation: Formation) => actions.tract.createFormation(clientNumber, projectNumber, formation),
    sequenceHorizons: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        sequence: Array<{ id: number; sequence: number; }>
    ) => actions.tract.sequenceHorizons(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, sequence),
    getUniqueHorizonIntervals: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => actions.tract.getUniqueHorizonIntervals(clientNumber, projectNumber, sectionNumber, tractNumber),
    addCounty: (clientNumber: number, projectNumber: number, county: County) => actions.county.createCounty(clientNumber, projectNumber, county),
    saveAddOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        values: AddOwnershipData
    ) => actions.tract.saveAddOwnership(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, values),
    updateHorizonInterval: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        horizon: HorizonInterval
    ) => actions.tract.updateHorizonInterval(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, horizon),
    updateTractNote: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        tractDetailData: TractDetailData
    ) => actions.tract.updateTractNote(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, tractDetailData),
    updateOwnershipNote: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownership: Ownership
    ) => actions.tract.updateOwnerNote(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownership),
    updateLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        leaseholds: Array<Leasehold>
    ) => actions.leasehold.updateLeaseholds(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, leaseholds),
    getLeaseholds: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, ownershipId: number) => actions.leasehold.getLeaseholds(clientNumber, projectNumber, sectionNumber, tractNumber, ownershipId),
    getLeaseholdsByTract: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number) => actions.leasehold.getLeaseholdsByTract(clientNumber, projectNumber, sectionNumber, tractNumber),
    getContracts: (clientNumber: number, projectNumber: number, ownershipId: number, inHanded: boolean) => actions.leasehold.getContracts(clientNumber, projectNumber, ownershipId, inHanded),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
    deleteOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number,
        ownershipOptions: ODataOptions
    ) => actions.tract.deleteOwnership(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId, ownershipOptions),
    getOwnershipContactCategories: (clientNumber: number, projectNumber: number) => actions.ownershipContactCategories.getOwnershipContactCategories(clientNumber, projectNumber),
    incrementOwnershipPage: (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number) => actions.tract.incrementOwnershipPage(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber),
    initializeOwnershipList: (config: ITableConfig) => actions.tract.initializeOwnerList(config),
    initializeOwnerTracts: () => actions.tract.initializeOwnerTracts(),
    clearSearchResults: () => actions.tract.clearSearchResults(),
    getProjectTags: (clientNumber: number, projectNumber: number) => actions.tags.getProjectTags(clientNumber, projectNumber),

    dumpOwnershipContactCategories: () => actions.ownershipContactCategories.dumpCategories(),
    getProjectStaff: (clientNumber: number, projectNumber: number) => actions.projectStaffing.getProjectStaffing(clientNumber, projectNumber),
    getSectionCounties: (clientNumber: number, projectNumber: number, sectionNumber: number, options: ODataOptions) => actions.county.getSectionCounties(clientNumber, projectNumber, sectionNumber, options),
    getEasternMapCounties: (clientNumber: number, projectNumber: number, mapNumber: number, options: ODataOptions) => actions.county.getEasternMapCounties(clientNumber, projectNumber, mapNumber, options),
    getProjectCounties: (clientNumber: number, projectNumber: number, options: ODataOptions) => actions.county.getProjectCounties(clientNumber, projectNumber, options),
    manageLeasehold: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number
    ) => actions.leasehold.manageleasehold(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId),
    promoteAdditionalOwnership: (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number
    ) => actions.tract.promoteAdditionalOwnership(clientNumber, projectNumber, sectionNumber, tractNumber, horizonNumber, ownershipId),
    verifyId: (context: string, id: string) => actions.search.verifyId(context, id),
    clearVerification: () => actions.search.clearVerification(),
    setVerificationMessage: (message: string) => actions.search.setVerificationMessage(message),
    cloneData: (context: string, options: string) => actions.clone.cloneData(context, options),
    // navigateAcquisition: (clientNumber: number, projectNumber: number, ownerLookUpId: number) =>
    //     actions.leaseGeneration.navigateAcquisition({ clientNumber, projectNumber, ownerLookUpId }),
    incrementAcqPage: (clientNumber: number, projectNumber: number) => actions.leaseGeneration.incrementAcqPage(clientNumber, projectNumber),
    registerOwnerships: (ownerships: PagedResultSet<Ownership>, selectedHorizon: number) => actions.tract.registerOwnerships(ownerships, selectedHorizon),
    getTownships: (clientNumber: number, projectNumber: number) => actions.tract.getTownships(clientNumber, projectNumber),
    getEasternTownships: (clientNumber: number, projectNumber: number) => actions.tract.getEasternTownships(clientNumber, projectNumber),
    getTownship: (clientNumber: number, projectNumber: number, townshipId: number) => actions.tract.getTownship(clientNumber, projectNumber, townshipId),
    getEasternTownship: (clientNumber: number, projectNumber: number, townshipId: number) => actions.tract.getEasternTownship(clientNumber, projectNumber, townshipId),
    getMap: (clientNumber: number, projectNumber: number, mapNumber: number) => actions.tract.getMap(clientNumber, projectNumber, mapNumber),
};

export default connect(mapStateToProps, mapDispatchToProps)(TractDetail);


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/TractDetail.tsx